/**
 * clock.ts — injectable time source.
 *
 * Systems and the game loop read time through a Clock so that tests can
 * control the passage of time deterministically (no direct Date.now()).
 */

export interface Clock {
  now(): number;
}

/** Real wall-clock time in milliseconds. */
export const systemClock: Clock = {
  now: () => Date.now(),
};

/** A controllable clock for tests. */
export class FakeClock implements Clock {
  constructor(private t = 0) {}
  now(): number {
    return this.t;
  }
  advance(ms: number): void {
    this.t += ms;
  }
  set(ms: number): void {
    this.t = ms;
  }
}
